import { Injectable } from '@angular/core';
import { MatDialog } from '@angular/material/dialog';
import { NavigationService } from '@services/navigation.service';
import { Observable } from 'rxjs';
import { NewCustomerComponent } from './new-customer/new-customer.component';

@Injectable({
  providedIn: 'root'
})
export class CustomerService {

  constructor(
    private matDialog: MatDialog,
    private navService: NavigationService
  ) { }

  goToNewCustomer() {
    return this.navService.goToNewCustomer();
  }

  openNewCustomerDialog(partner: any): Observable<any> {
    return this.matDialog.open(
      NewCustomerComponent,
      {
        data: {
          partner
        },
        minWidth: '60vw'
      }
    ).afterClosed();
  }
}
